import Dropzone from "react-dropzone";
import SVG from "react-inlinesvg";
import { cn } from "src/lib/cn";
import { Text } from "src/sudokit/components/Text";
import { IMAGE_DROPZONE_ACCEPT, handleImagesDropRejected, handleImagesDropped } from "./lib/imageDropHandlers";

interface EntityImageAddMoreButtonProps {
  onFilesAdded: (files: File[]) => void;
  onError: (message: string | null) => void;
}

export default function EntityImageAddMoreButton({ onFilesAdded, onError }: EntityImageAddMoreButtonProps) {
  return (
    <Dropzone
      accept={IMAGE_DROPZONE_ACCEPT}
      multiple
      onDrop={(acceptedFiles) => handleImagesDropped(acceptedFiles, onFilesAdded, onError)}
      onDropRejected={() => handleImagesDropRejected(onError)}
    >
      {({ getRootProps, getInputProps, isDragActive }) => (
        <div
          {...getRootProps()}
          className={cn(
            "box-border inline-flex h-11 shrink-0 cursor-pointer items-center gap-2 rounded-xl border border-dashed py-1 pl-1 pr-3 text-left transition-colors duration-200 ease-out",
            isDragActive ? "border-app-primary-cta-high-contrast bg-[color-mix(in_srgb,var(--primary-cta-high-contrast)_12%,transparent)]" : "border-app-grey-3 hover:border-app-grey-2",
          )}
        >
          <input {...getInputProps()} />
          <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[color-mix(in_srgb,var(--primary-cta-high-contrast)_8%,transparent)]">
            <SVG
              src="/assets/image.svg"
              width={16}
              height={16}
              className="[&_path]:fill-app-primary-cta-high-contrast"
              aria-hidden="true"
            />
          </div>
          <div className="grid">
            <Text
              size="sm"
              color="grey-1"
              className="invisible col-start-1 row-start-1 whitespace-nowrap"
              aria-hidden="true"
            >
              Drop or click to select more images
            </Text>
            <Text
              size="sm"
              color={isDragActive ? "primary-cta-high-contrast" : "grey-1"}
              className="col-start-1 row-start-1 whitespace-nowrap"
            >
              {isDragActive ? "Drop your images here" : "Drop or click to select more images"}
            </Text>
          </div>
        </div>
      )}
    </Dropzone>
  );
}
